<template>
  <div class="appointments">
    <el-col class="userinfoList infoPub" style="width: 990px">
      <div class="exhContent">
        <!-- 搜索组件 -->
        <search-bar
          :selectType="ExhIndexType"
          :searchInputPlc="language.fairName"
          :searchSelectPlc="language.exhibitionState"
          @changeExhibitionState="toSearch"
          :isExport="true"
          isExportFlag = "1"
          @toSearch="toSearch"
        />
        <!--内容-->
        <limit-count v-loading="loading" :language="language" :listData="listData" @handleCancel="handleCancel"/>
        <!--分页-->
        <el-pagination
          v-show="pageTotal > 0"
          background
          :page-size="pageSize"
          :layout="layout"
          :total="pageTotal"
          :current-page="currentPage"
          @current-change="pageChange"
        ></el-pagination>
      </div>
    </el-col>
    <download-dialog :show.sync="downloadShow"/>
  </div>
</template>

<script>
  import searchBar from "../components/searchbar/searchbar";
  import {language} from "../../../language/get";
  import Cookie from "../../../common/cookie";
  import {ExhIndexType} from "../../../common/constant/exhibition";
  import {mapGetters} from "vuex";
  import {SubscribeGz} from "../../../api/btManage";
  import {isEmpty, isInternet} from "../../../common/validate";
  import downloadDialog from "../../../components/DownloadDialog/index";
  import limitCount from "./limitCount/index"
  import {subscribeCancel} from "../../../api/btManage";
  const pubLanguage = language();
  export default {
    components: {
      searchBar,
      downloadDialog,
      limitCount
    },
    computed: {
      ...mapGetters(["token", "userInfo"])
    },
    data() {
      return {
        lan: Cookie.get("lang"),
        language: pubLanguage,
        loading: false,
        listData: [],
        ExhIndexType,
        //page
        pageTotal: 190,
        pageSize: 4,
        currentPage: 1,
        layout: "prev, pager, next, jumper",
        //搜索条件
        getStateCon: null,
        getValCon: null,
        //提示下载
        downloadShow: false
      }
    },
    methods: {
      toSearch(state, val) {
        this.getStateCon = state;
        this.getValCon = val;
        this.currentPage = 1;
        this.loadData();
      },
      loadData() {
        const props = {
          token: this.token,
          exhibitionState:  this.getStateCon,
          keyword:  this.getValCon,
          currentPage: this.currentPage,
          lan: this.lan,
          numberPage: this.pageSize
        }
        SubscribeGz(props).then(res => {
          if (res.type != "1"){
            if (this.lan == "ch") {
              return this.$message.error({message: res.text, offset: 120})
            }
            return this.$message.error({message: res.text_en, offset: 120})
          }

          this.pageTotal = parseInt(res.datacount)
          
          this.listData = res.data
        })
      },
      pageChange(v) {
       this.currentPage = v;
       this.loadData();
      },
      handleCancel(data){
        console.log(data)
        const props = {
          token: this.token,
          broadcast_id: data.id
        };
        subscribeCancel(props).then(res => {
          if (res.type != "1") {
            if (this.lan == "ch") {
              return this.$message.error({message: res.text, offset: 120})
            }
            return this.$message.error({message: res.text_en, offset: 120})
          }
          if (this.lan == "ch") {
            this.$message.success({message: res.text, offset: 120})
          }else {
            this.$message.success({message: res.text_en, offset: 120})
          }
          this.loadData();
        })
      }
    },
    mounted() {
      this.loadData();
    }

  }
</script>
<style scoped>
</style>
<style>

  .appointments .el-pagination {
    text-align: center;
    margin-top: 32px;
  }
  
  .appointments >>> .el-pagination .el-pager li{
    width: 30px;
    height: 30px;
    line-height: 30px;
    background:none;
    font-size: 14px;
  }
  .appointments >>> .el-pagination .btn-next{
    width: 30px;
    height: 30px;
    line-height: 30px;
    background: none;
  }
  .appointments >>> .el-pagination .btn-prev{
    width: 30px;
    height: 30px;
    line-height: 30px;
    color: #000;
    background: none;
  }
  .appointments >>> .el-pagination .el-input__inner{
    width: 30px;
    height: 30px;
    line-height: 25px;
    margin-top: -15px !important;
  }
  .appointments .el-pagination .el-pagination__jump{
    width: 25px;
    height: 25px;
    line-height: 25px;
  }
</style>
